import { Avatar, Chip, FormControl, Grid, MenuItem, Select } from "@material-ui/core"
import { Card } from 'react-bootstrap'
// import { DoneIcon} from '@material-ui/icons'

/*
    team1 : [player]
    team2 : [player]

    player : {
        displayName,
        email,
        id,
        uid,
    }
*/
export default function EditRubber(props){
    let name = props.name
    let t1players = props.team1 // [player]
    let t2players = props.team2

    let t1score = props.t1score || props.t1score === 0? props.t1score : "-"
    let sett1score = props.sett1score
    
    let t2score = props.t2score || props.t2score === 0? props.t2score : "-"
    let sett2score = props.sett2score

    function getNameInitials(name){
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

        let initials = [...name.matchAll(rgx)] || [];

        initials = (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        return initials
    }

    const vs = (
        <Grid>
            <b>vs</b>
        </Grid>   
    )

    const displayt1 = t1players.map((player) => {
        if (!player){
            return(
                <div>
                    <Chip
                        size="small"
                        avatar={<Avatar> {getNameInitials("null")} </Avatar>}
                        label="null"
                        clickable
                        variant="outlined"
                        color="secondary"
                        // onDelete={handleDelete}
                        // deleteIcon={<DoneIcon />}
                    />
                </div> 
            )
        }
        return(
            <div>
                <Grid item xs={3}>
                    <Chip
                        size="medium"
                        avatar={<Avatar> {getNameInitials(player.player.displayName)} </Avatar>}
                        label={player.player.displayName}
                        clickable
                        color="primary"
                        // onDelete={handleDelete}
                        // deleteIcon={<DoneIcon />}
                    />
                </Grid>
            </div> 
         
        )
    })

    const displayt2 = t2players.map((player) => {
        if (!player){
            return(
                <div>
                    <Chip
                        size="small"
                        avatar={<Avatar> {getNameInitials("null")} </Avatar>}
                        label="null"
                        clickable
                        variant="outlined"
                        color="secondary"
                    />
                </div> 
            )
        }
        return(
            <div>
                <Grid item xs={3}>
                    <Chip
                        size="medium"
                        avatar={<Avatar> {getNameInitials(player.player.displayName)} </Avatar>}
                        label={player.player.displayName}
                        clickable
                        variant="default"
                        color=""
                    />
                </Grid>
            </div> 
         
        )
    })

    const team1 = (
        <div>
            <Grid container spacing={1}>
                {displayt1}
            </Grid>
        </div>
    )

    const team2 = (
        <div>
            <Grid container spacing={1}>
                {displayt2}
            </Grid>
        </div>
    )

    return (
        <div>
            <Card>
                <Card.Body>
                    <div>
                        {name}
                    </div>
                    <Grid direction="row" container justifyContent="space-around" alignItems="center" spacing={3}>
                        <Grid item  >
                            {team1}
                        </Grid>
                            
                        <Grid item>
                            <FormControl >
                                {/* <InputLabel id="demo-simple-select-label"></InputLabel> */}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={t1score}
                                    onChange={(event) => {console.log(event.target.value);sett1score(event.target.value)}}
                                >
                                    <MenuItem value={'-'}>-</MenuItem>
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={6}>6</MenuItem>
                                    <MenuItem value={7}>7</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {vs}
                        <Grid item>
                            <FormControl >
                                <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={t2score}
                                onChange={(event) => {console.log(event.target.value); sett2score(event.target.value)}}
                                >
                                    <MenuItem value={'-'}>-</MenuItem>
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={6}>6</MenuItem>
                                    <MenuItem value={7}>7</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item >
                            {team2}
                        </Grid>
                    </Grid>
                </Card.Body>
            </Card>
        </div>
    )
}